<template>
<v-container fluid>
    <v-row
        align="center"
        justify="center"
        class="mx-0"
    >
        <v-col cols="12">
            <v-breadcrumbs :items="breadcrumbItems" large></v-breadcrumbs>
        </v-col>
    </v-row>
    <v-row class="mx-0" justify="center" align="center">
        <v-col>
            <span class="text-h4"> Your Newsfeed</span>
        </v-col>
        <v-col>
            <p class="pa-0 ma-0 text-right">
                <AddNewPostDialog/>
            </p>
        </v-col>
    </v-row>
    <v-row
        align="center"
        justify="center"
        class="mx-0 mt-5"
      >
        <v-col v-for="post in posts" :key="post.postId" cols="12">
            <PostViewer :post="post"/>
        </v-col>
    </v-row>
    <v-row
        align="center"
        justify="center"
        class="mx-0 mt-5"
      >
        <v-col>
            <p class="pa-0 ma-0 text-center">
                <v-btn v-if="firstDocumentOnLoad != null && (!isEndReached) && posts.length >= pageSize" outlined depressed color="secondary" @click="handleLoadMore" large>Load More</v-btn>
            </p>
        </v-col>
    </v-row>
</v-container>
    
</template>
<script>
import PostViewer from '@/components/PostViewer'
import AddNewPostDialog from '@/components/AddNewPostDialog'
import { mapGetters } from 'vuex'
import { onSnapshot, orderBy, where, limit, startAfter, startAt, endBefore} from "firebase/firestore";
import {getQueryPostCollection, queryPostCollection} from "@/shared/firebase_utils";

export default {
    name: 'Newsfeed',

    components: {
        PostViewer,
        AddNewPostDialog
    },

    async created() {
        try{
            await this.initializeFirstDocumentOnLoad();
            if (this.firstDocumentOnLoad != null) {
                this.loadFirstPage();
            }
            this.loadNewDocuments();
        } catch(error) {
            console.log (error);
        }
    },

    data() {
        return {
            isEndReached: false,
            lastLoadedDocumnet: null,
            pageSize: 20,
            firstDocumentOnLoad: null,
            posts: [],
            breadcrumbItems: [
                {
                    text: 'Home',
                    disabled: false,
                    to: '/',
                },
                {
                    text: 'Pappyon Premiere',
                    disabled: false,
                    to: '/pappyonPremiere',
                },
                {
                    text: 'Premiere Business Newsfeed',
                    disabled: true,
                },
            ],
        };
    },

    methods: {
        handleLoadMore() {
            onSnapshot(
                queryPostCollection(
                    where('businessProfileId','==', this.userProfile.businessProfileId),
                    orderBy('createdAt','desc'),
                    limit(this.pageSize),
                    startAfter(this.lastLoadedDocumnet)
                ),
                (querySnapshot) => {
                if(querySnapshot.docs.length == 0) {
                    this.isEndReached = true;
                }
                const changes = querySnapshot.docChanges();
                changes.forEach((change)=> this.handleDocumentChange(change));
            });
        },
        async loadNewDocuments () {


            onSnapshot(
                queryPostCollection(
                    where('businessProfileId','==', this.userProfile.businessProfileId),
                    orderBy('createdAt','desc'),
                    endBefore(this.firstDocumentOnLoad),
                ),
                (querySnapshot) => {
                const changes = querySnapshot.docChanges();
                changes.forEach((change)=> this.handleDocumentChange(change));
            });
        },
        async initializeFirstDocumentOnLoad() {
            await getQueryPostCollection(
                where('businessProfileId','==', this.userProfile.businessProfileId),
                orderBy('createdAt','desc'),
                limit(1),
            )
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    this.firstDocumentOnLoad = doc;
                });
            }).catch((error) => {
                console.log('Error while retriving the first document on load');
                console.log(error);
            });
        },
        async loadFirstPage() {
            await onSnapshot(
                queryPostCollection(
                    where('businessProfileId','==', this.userProfile.businessProfileId),
                    orderBy('createdAt','desc'),
                    startAt(this.firstDocumentOnLoad),
                    limit(this.pageSize)),
                (querySnapshot) => {
                const changes = querySnapshot.docChanges();
                changes.forEach(async (change)=> this.handleDocumentChange(change));
            });
        },
        async handleDocumentChange(change) {
            let addedDocument;
            if (change.type === 'added' || change.type == 'modified') {
                addedDocument = {
                    ...change.doc.data(),
                    postId: change.doc.id,
                };
            }
            if (change.type === 'added') {
                if(this.posts.length != 0 && addedDocument.createdAt.toDate() > this.posts[0].createdAt.toDate()) {
                    this.posts.unshift(addedDocument);
                } else{
                    this.posts.push(addedDocument);
                    this.lastLoadedDocumnet = change.doc;
                }
            }
            else if (change.type == 'modified') {
                //Replace the old object within the array with the modified object
                this.posts.forEach((item, index)=> { 
                    if (item.postId ==  change.doc.id)  {
                        this.posts.splice(index, 1, addedDocument)
                    }
                });
            }
            else if (change.type == 'removed') {
                //Remove the object from the array
                this.posts.forEach((item, index)=> { 
                    if (item.postId ==  change.doc.id)  {
                    this.posts.splice(index, 1);
                    }
                });
            }
        },

        
    },
    computed: {
        ...mapGetters(['userProfile']),
    },
}
</script>